import * as types from './types'

export default {
  [types.SET_SEARCH_TERM](state, text) {
    if (text !== undefined && text !== null) {
      state.searchTerm = text
    }
  },
  [types.SET_PAGE_SIZE](state, value) {
    if (value !== undefined && value !== null) {
      state.pageSize = parseInt(value)
    }
  },
  [types.SET_SORT_DIR](state, text) {
    if (text !== undefined && text !== null) {
      state.sortDir = text
    }
  },
  [types.SET_ORDER_BY](state, text) {
    if (text !== undefined && text !== null) {
      state.orderBy = text
    }
  },
  [types.SET_STATUS](state, value) {
    if (value !== undefined && value !== null) {
      state.status = value
    }
  },
  [types.SET_FILTER_BY](state, value) {
    if (value !== undefined && value !== null) {
      state.filterBy = parseInt(value)
    }
  },
  [types.INIT_USER](state) {
    state.user = JSON.parse(JSON.stringify(state.default))
  },
  [types.SET_HIGHLIGHT](state, value) {
    state.highlight = value
  },
  [types.SET_HIGHLIGHT_PASSWORD](state, value) {
    state.highlightPassword = value
  },
  [types.SET_USER_ROLE](state, role) {
    state.user.Role = role.name
    state.user.Roles = []
    state.user.Roles.push({
      Name: role.name,
      Id: role.id
    })
  },
  [types.SET_SOURCE](state, source) {
    state.source = source
  },
  [types.SET_USER](state, data) {
    state.user = JSON.parse(JSON.stringify(state.default))
    if (data.length > 0) {
      state.user = data[0]
    }
  },
  [types.SET_USERS](state, data) {
    state.totalUsers = 0
    state.users = []
    if (data !== undefined && data !== null) {
      if (data.length > 0) {
        state.totalUsers = data[0].TotalItems
        for (var item of data) {
          item.isChecked = false
        }
        state.users = data
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/users/mutations.js